/** Idle: encouragement TTS then final deadline before auto-submit (aligned with other activities). */
export const IDLE_ENCOURAGEMENT_TIMEOUT = 6000; // 6s
export const IDLE_SUBMIT_TIMEOUT = 60000; // 1 min

export const TIME_BETWEEN_OPTIONS = 1000;

/**
 * Sentinel in writtenInstructions marking a fill-in-the-blank gap. The prompt bar splits the
 * text on this token and renders a styled underline span in its place (see MmcPromptBar).
 * Authored in the item bank as literal text, e.g. "El gato es muy [BLANK] y duerme todo el día."
 */
export const BLANK_TOKEN = '[BLANK]';
export const MAX_REPLAYS = 5;
export const HIGHLIGHT_DURATION = 2000;

/** Prompt bar text shrink-to-fit: never scale below this, target this many rows before shrinking. */
export const MIN_PROMPT_FONT_SIZE_PX = 18;
export const PROMPT_TARGET_MAX_ROWS = 3;

export const LOG =
  process.env.NODE_ENV !== 'production'
    ? (...args) => console.log('[MMC]', ...args)
    : () => {};

/** UI element names this activity handles for show/hide/highlight/click triggers */
export const UI_ELEMENTS = new Set(['repeat', 'prompt', 'options', 'video', 'image', 'submit']);
